<template>
    <div class="pm-tutorial-item">
        <picture class="pm-tutorial-item-thumb" :style="'background-image: url('+ item.src +'.jpg)'">
            <small class="pm-tutorial-item-tag" :style="{ backgroundColor: item.tagColor }">{{ item.tag }}</small>
            <small class="pm-tutorial-item-duration">{{ item.duration }}</small>
        </picture>
        <div>
            <h3 class="pm-tutorial-item-title" v-html="item.title"></h3>
            <div class="pm-tutorial-item-description" v-html="item.description"></div>
        </div>
    </div>
</template>

<style>
    .pm-tutorial-item {
        background: #fff;
        margin-bottom: 10px;
        position: relative;
        padding-bottom: 26px;
    }

    .pm-tutorial-item {
        display: flex;
        align-items: center;
    }
    .pm-tutorial-item-thumb {
        height: 100px;
        width: 170px;
        flex-shrink: 0;
        margin: 0 20px 0 0;
    }

    .pm-tutorial-item:after {
        content: "___";
        position: absolute;
        bottom: 8px;
        left: 0;
        right: 0;
        text-align: center;
        opacity: .25;
    }

    .pm-tutorial-item-thumb {
        display: block;
        height: 100px;
        background: #eee;
        margin-bottom: 12px;
        border-radius: 3px;
        box-shadow: 2px 2px 3px rgb(0 0 0 / 35%);
        max-width: 100%;
        position: relative;
        background-size: cover;
        background-position: center center;
        border: 1px solid #eee;
    }
    .pm-tutorial-item-duration {
        display: block;
        position: absolute;
        bottom: -7px;
        right: 10px;
        background: #a6a7aa;
        border-radius: 3px;
        padding: 2px 4px;
        font-size: 10px;
        color: #fff;
        line-height: 1;
        font-weight: 600;
    }
    .pm-tutorial-item-tag {
        display: block;
        position: absolute;
        bottom: -7px;
        right: 40px;
        border-radius: 3px;
        padding: 2px 4px;
        font-size: 10px;
        color: #fff;
        line-height: 1;
        font-weight: 800;
    }
    h3.pm-tutorial-item-title {
        font-size: 15px;
        line-height: 1.15;
        font-weight: 800!important;
        margin-bottom: 8px;
    }
    .pm-tutorial-item-description {
        line-height: 1.3;
        font-size: 12px;
        color: #444;
    }
    .pm-tutorial-item-description b {
        font-weight: 600;
    }
</style>
<script>
export default {
    props: {
        item: {
            type: Object,
        },
    },
    data: () => ({
        upVotes: 0,
        downVotes: 0,
        upVoted: false,
        downVoted: false,
    }),
    created() {
        this.getVotes();
    },
    methods: {
        getVotes() {
            this.upVotes = this.item.up + (localStorage.getItem('faqVote_' + this.item.id) === "1" ? 1 : 0);
            this.downVotes = this.item.down + (localStorage.getItem('faqVote_' + this.item.id) === "-1" ? 1 : 0);
            this.upVoted = localStorage.getItem('faqVote_' + this.item.id) === "1";
            this.downVoted = localStorage.getItem('faqVote_' + this.item.id) === "-1";
        },
        vote(val) {
            localStorage.setItem('faqVote_' + this.item.id, val.toString());
            this.getVotes();
            window.Tracker.logEvent({
                event_name: "vote_" + val > 0 ? "up" : "down",
                event_category: "faq",
                event_label: this.item.id,
            });
        }
    }
}
</script>
